<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100">
            <h1 class="title">Meeting Rooms <br>
              <small class="text-white">Let's Reserve Online</small>
            </h1>
            <!-- <h4>
              Example
            </h4> -->
            <br />
            <md-button
              href="/chooseMeetingDate"
              class="md-orange md-lg"
              target="_self"
              ><md-icon>today</md-icon>Reservation
            </md-button>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center">
              <h2 class="title text-center">Meeting Rooms</h2>
              <h5 class="md-body-3 text-left">
                Days Inn Sherman TX is a garden look, INTERIOR corridor hotel conveniently located off Highway 75 at exit 56. We have on site bar and restaurant, and we have a movie theater, bowling, amusement arcade right next door! Days Inn Sherman offers competitive guestroom rates and the only meeting/party rooms available to rent in the area, free breakfast, truck parking, a game room with pool table and shuffle board where our guests can wind down their day with relaxing entertainment. Guests can stay fit during their stay with a swim in our outdoor pool or get in a great workout in our on-site fitness center. Free Wi-Fi Internet access throughout the hotel ensures connectivity and productivity, along with access to our business center where you can check emails, print schedules, and fax documents to the home office. The on-site breakfast facility serves up a delicious HOT breakfast every morning, where you can also enjoy fresh coffee. Each one of the 99 well-appointed guest rooms comes with plush bedding, flat screen televisions with cable access, coffee-maker, microwave and refrigerator, iron & ironing board, hairdryer, complimentary high speed Wi-Fi and a desk with a work chair.
              </h5>
              <md-button
                href="/chooseMeetingDate"
                class="md-orange md-lg"
                target="_self"
              ><md-icon>today</md-icon>Reservation Now
            </md-button>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="md-layout t_align">
            <div class="md-layout-item md-size-60">
              <img :src="img1" alt="">
            </div>
            <div class="md-layout-item md-size-40 text-center">
              <h3 class="title">Banquet Halls</h3>
              <h5 class="text-right">Days Inn Hotel Banquet Hall, Sherman TX - #1 Best Value Hotel in Sherman Rated by Tripadvisor.com! Meeting/Party space rental for Birthday party, Wedding Venues, Business meeting, Family Reunion, Holidays, Conventions, Corporate Meetings, Anniversary Parties, Bridal Showers, Receptions place, Retirement Parties, Conference Rooms or any type of social functions, gatherings and occasions. We have sittings for up to 250 guests. LOW RATES!</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="md-layout t_align">
            <div class="md-layout-item md-size-40 text-center">
              <h3 class="title">Low Rate</h3>
              <h5 class="text-left">
                Our low rates include Ballroom with Tables, Chairs, Buffet Tables, Dance Floor. Coffee/Tea Station is Additional. Free parking and Wi-Fi. </h5>
            </div>
            <div class="md-layout-item md-size-60">
              <img :src="img2" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="md-layout t_align">
            <div class="md-layout-item md-size-60">
              <img :src="img3" alt="">
            </div>
            <div class="md-layout-item md-size-40 text-center">
              <h3 class="title">Location</h3>
              <h5 class="text-right">
                We are conveniently located at the intersection of US75 and FM1417, the south end of city Sherman, Texas, which is about 20 mins north of the most prosperous cities of McKinney and Allen, 35 mins north of Plano, 30 mins northeast of Frisco, one hour to DFW airport! We have onsite bar and restaurant and a movie theater, bowling, and amusement arcade next door!</h5>
            </div>
          </div>
        </div>
      </div>  
      <div class="section">
        <div class="container">
          <div class="md-layout t_align">
            <div class="md-layout-item md-size-40 text-center">
              <h3 class="title">Events</h3>
              <h5 class="text-left">
                Available now to host your next event!!!
                Whether it's a Birthday party, Weddings, Business meeting, Family Reunion or any type of gathering and occasions, our hotel has packages for fun and active event!!
                </h5>
            </div>
            <div class="md-layout-item md-size-60">
              <img :src="img5" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="md-layout t_align">
            <div class="md-layout-item md-size-60">
              <img :src="img4" alt="">
            </div>
            <div class="md-layout-item md-size-40 text-center">
              <h3 class="title">Rooms</h3>
              <h5 class="text-right">We have 5 different conference rooms available with sizes from 600sq ft to 3250sq ft. Discounted guestroom rate for party/conference attendees!
              Call or Text to (903) 718-0189 or stop by any time of the day for an onsite tour!</h5>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="section section-bottom">
        <div class="container">
          <div class="md-layout-item md-size-100 text-center">
            <h3 class="title">Book Your Meeting Room Today!</h3>
            <h5 class="text-left">Celebrate your next special event, whether it be a wedding rehearsal, baby shower, corporate celebration, club events and more, with us. We offer customized menus at various price points to fit your group needs. For smaller events, we offer a private dining room that seats up to 14 around our farmhouse dining table. </h5>
            <md-button
              href="/chooseMeetingDate"
              class="md-orange md-lg"
              target="_self"
              ><md-icon>today</md-icon>Check Availability
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/meeting_header.jpg")
    },
    img1: {
      type: String,
      default: require("@/assets/img/mmeetingAustin.jpg")
    },
    img2: {
      type: String,
      default: require("@/assets/img/mMeeting_small2.jpg")
    },
    img3: {
      type: String,
      default: require("@/assets/img/meet_location.jpg")
    },
    img4: {
      type: String,
      default: require("@/assets/img/meeting_restaurant1.jpg")
    },
    img5: {
      type: String,
      default: require("@/assets/img/meeting_restaurant2.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 40px;
}
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.page-header {
  b {
    font-size: 4.2rem
  }
}
.elevation-demo {
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
}
.t_align{
  align-items: center;
}
hr {
  margin-top: 1rem;
  border: 0;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.md-content {
  width: 25%;
  height: auto;
  // margin: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    width: 100%;
    height: 100%;
    position: relative;
    i {
      display: table-cell;
      position: absolute;
      top:0;
      right: 0;
      bottom: 0;
      left: 0;
      font-size: 2.0rem;
      font-weight: bold;
      vertical-align: middle;
      text-align: center;
      font-style: normal; 
      background: rgba(245, 124, 0, 0.5);
      color: #fff;
      opacity: 0;
      z-index: 9;
      padding: 50% 0 0 0;
      transition: opacity 0.8s ease 0s;
    }
    &:hover {
      i {
        opacity: 1;
      }
    }
  }
}
</style>
